//import liraries
import React, { useEffect, useState } from "react";
import { View, Text,  TouchableOpacity, Image } from "react-native";
import QuickLinks from "../Profile/QuickLinks";
import CustomButton from "../../common/CustomButton";
import { autoPayDisable } from "../../api/apiManager"
import { autoPayEnable } from "../../api/apiManager"
import ModalAlert from "../../common/ModalAlert";
import AsyncStorageFunc from '../../utilities/asyncStorage';
import RootNavigation from "../../utilities/RootNavigation";
import useStyles from "./ChangeAcType_Styles";
import Loader from "../../common/Loader";
const ChangeAcType = (props) => {
  const [value, setValue] = useState("");
  const styles = useStyles()
 const [poolType, setPoolType] = useState("")
 const [loading, setLoading] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });

  const onCloseModal = () => {
    setAlertModalVisible(false);
   RootNavigation.navigate("Profile/PoolAccount")
  };


  const onConfirm = () => {
    setLoading(true);
    if (value == "1") {
      autoPayEnable()
        .then((res) => {
          setLoading(false);
          if (res.statusCode == 200) {
            setAlertModal({
              title: "Successful",
              status: "success",
              message: res?.message || "",
              navigateScreen: "PoolAccountScreen",
              actionButton: "OK",
            });
            setAlertModalVisible(true);
          } else {
            setAlertModal({
              title: "Error",
              status: "error",
              message: res?.message || "",
              actionButton: "OK",
            });
            setAlertModalVisible(true);
          }

        })
        .catch((err) => {
          setLoading(false);
          setAlertModal({
            title: "Error",
            status: "error",
            message: err?.message || "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        });
    }
    if (value == "2") {
      autoPayDisable()
        .then((res) => {
          setLoading(false);
          if (res.statusCode == 200) {
            setAlertModal({
              title: "Successful",
              status: "success",
              message: res?.message || "",
              actionButton: "OK",
            });
            setAlertModalVisible(true);
          } else {
            setAlertModal({
              title: "Error",
              status: "error",
              message: res?.message || "",
              actionButton: "OK",
            });
            setAlertModalVisible(true);
          }
        })
        .catch((err) => {
          setLoading(false);
          setAlertModal({
            title: "Error",
            status: "error",
            message: err?.message || "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        });
    }
  };

  useEffect(() => {
    AsyncStorageFunc.getData("poolSelection").then((poolType) => {
      setPoolType(poolType)
      setValue(poolType == "N" ? "1" : "2")
    })
    console.log("pooltype", poolType)
  }, [])


  return (
    <View style={styles.mainContainer}>
      <View style={styles.iconContainer}>
        <TouchableOpacity onPress={() => { RootNavigation.navigate("Profile/PoolAccount") }}>
          <Image
            source={require("../../assets/images/back.png")}
            style={styles.backIcon} />
        </TouchableOpacity>
        <Text style={styles.textStyle}>{"Pool Account Details"}</Text>
      </View>

      <View style={styles.rowContainer}>

        <View style={styles.subContainer}>
          <View style={styles.acTypeView}>
            <Text style={styles.autoPayHeading}>
              {"AutoPay Pool Account"}
            </Text>
            <Text style={styles.autoPayText}>
              {"All vehicle tags will be maintained at 0 balance, if any transaction happens on the tag of a vehicle, the amount will be deducted directly from Pool"}
            </Text>
          </View>

          <View style={styles.acTypeView}>
            <Text style={styles.autoPayHeading}>
              {"Manual Pool Account"}
            </Text>
            <Text style={styles.autoPayText}>
              {"Manual Pool Account - Transfer money from Pool Account to vehicles manually, individual vehicle balances need to be monitored"}
            </Text>
          </View>
        </View>

        <View style={styles.columnView}>
          <View style={styles.choosePoolAccountTypeView}>
            <Text style={styles.choosePoolAccountTypeHeading}>
              {" Choose Pool Account Type"}
            </Text>
            <Text style={styles.choosePoolAccountTypeText}>
              {"Transfers can be made in two different cases listed below"}
            </Text>
          </View>

          <View style={styles.radioBtnView}>
            {
              poolType == "N"
                ? <View>
                   <View style={styles.selectionContainerStyle}>
                  <TouchableOpacity onPress={() => setValue("1")}
                    style={styles.radiobuttonOutSideStyle} >
                    {
                      value == "1"
                        ? <View style={styles.radioButtonInsideStyle} />
                        : null
                    }
                  </TouchableOpacity>
                  <Text style={{ fontSize: 13, color: "#02122c", marginLeft: 7 }}>
                    {"AutoPay Pool Account"}
                  </Text>
                </View>
                  <View style={{ flexDirection: "row", marginTop: 15 }}>
                    <View
                      style={[styles.radiobuttonOutSideStyle, { borderColor: "#c3c3c3" }]} >
                    </View>
                    <Text style={{ fontSize: 13, color: "#c3c3c3", marginLeft: 7 }}>
                      {"Manual Pool Account"}
                    </Text>
                  </View>
                </View>
                :
                <View>
                  <View style={{ flexDirection: "row", marginBottom: 15 }}>
                    <View
                      style={[styles.radiobuttonOutSideStyle, { borderColor: "#c3c3c3" }]} >
                    </View>
                    <Text style={{ fontSize: 13, color: "#c3c3c3", marginLeft: 7 }}>
                      {"AutoPay Pool Account"}
                    </Text>
                  </View>
                  <View style={styles.selectionContainerStyle}>
                    <TouchableOpacity onPress={() => setValue("2")}
                      style={styles.radiobuttonOutSideStyle} >
                      {
                        value == "2"
                          ? <View style={styles.radioButtonInsideStyle} />
                          : null
                      }
                    </TouchableOpacity>
                    <Text style={{ fontSize: 13, color: "#02122c", marginLeft: 7 }}>
                      {"Manual Pool Account"}
                    </Text>
                  </View>
                </View>
            }
          </View>
        </View>

      </View>

      <View style={styles.customButton}>
        <CustomButton
          text="Save Changes"
          onPress={() => onConfirm()}
        />
      </View>

      <View>
        <QuickLinks
          navigation={props.navigation}
          activeScreen={"Pool Account Details"}
          setScreen={(layout) => props?.setScreen(layout)}
          setIsManual={(layout) => props?.setSelectedLayout(layout)}
          setSelectedLayout={props?.setSelectedLayout}
        />
      </View>
      {loading ? <Loader /> :<></>}
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
    </View>
  );
};


//make this component available to the app
export default ChangeAcType;
